
import { defineAsyncComponent, defineComponent, ref } from "vue";
import { CONSTANTS } from "@/graphql/utils/utils";

/**
 * When lazy tabview mode is enabled,
 * hidden tabs are not rendered at all. Defaults to false that hides tabs with css.
 * lazy mode is perfect for lazy component definition (defineAsyncComponent)
 */
export default defineComponent({
  name: "Rapport",
  components: {
    SalesRapport: defineAsyncComponent(
      () => import("@/components/rapport/SalesRapport.vue")
    ),
    StocksExpirations: defineAsyncComponent(
      () => import("@/components/rapport/StocksExpirations.vue")
    ),
    ExpensesRapport: defineAsyncComponent(
      () => import("@/components/rapport/ExpensesRapport.vue")
    ),
    ComparisonRapport: defineAsyncComponent(
      () => import("@/components/rapport/ComparisonRapport.vue")
    ),
    ProductStockRapport: defineAsyncComponent(
      () => import("@/components/rapport/ProductStockRapport.vue")
    ),
    StockMovementsRapport: defineAsyncComponent(
      () => import("@/components/rapport/StockMovementsRapport.vue")
    ),
    SequencesRapport: defineAsyncComponent(
      () => import("@/components/rapport/SequencesRapport.vue")
    ),
    ProductMovementsRapport: defineAsyncComponent(
      () => import("@/components/rapport/ProductMovementsRapport.vue")
    ),
    RepportTicketIncome: defineAsyncComponent(
      () => import("@/components/rapport/RepportTicketIncome.vue")
    ),
  },
  setup() {
    function saveActive(index: number) {
      sessionStorage.setItem(CONSTANTS.RAPPORT_INDEX, String(index));
    }
    const index = sessionStorage.getItem(CONSTANTS.RAPPORT_INDEX);
    const active = ref(index ? Number(index) : 0);
    return {
      active,
      saveActive,
    };
  },
});
